import "../style.css";
import SEO from "../components/SEO";
import SiteFooter from "../components/SiteFooter";

function Services() {
  return (


    <>



<SEO
  title="Laptop Repair & Service"
  description="Laptop repair, OS installation, SSD upgrade, RAM upgrade and software service available in Namakkal."
  url="https://lappylaptops.com/services"
/>






    <div className="services-page">
      {/* HEADER */}
      <div className="services-header">
        <h2>Our Services</h2>
        <p>Everything you need for laptops — sales, repair & support</p>
      </div>
      {/* SERVICES GRID */}
      <div className="services-list">
        <div className="service-box">
          <span>💻</span>
          <h3>Laptop Sales</h3>
          <p>New & refurbished laptops with best price and warranty.</p>
        </div>

        <div className="service-box">
          <span>🛠️</span>
          <h3>Laptop Repair</h3>
          <p>Hardware & software repair by experienced technicians.</p>
        </div>

        <div className="service-box">
          <span>⚡</span>
          <h3>SSD & RAM Upgrade</h3>
          <p>Boost laptop speed with SSD & RAM upgrades.</p>
        </div>

        <div className="service-box">
          <span>🔋</span>
          <h3>Battery Replacement</h3>
          <p>Original & compatible batteries with warranty.</p>
        </div>

        <div className="service-box">
          <span>🎧</span>
          <h3>Accessories</h3>
          <p>Chargers, bags, headphones, keyboard & mouse.</p>
        </div>

        <div className="service-box">
          <span>🧹</span>
          <h3>Laptop Cleaning</h3>
          <p>Internal fan & thermal cleaning to reduce heating.</p>
        </div>

        <div className="service-box">
          <span>🖥️</span>
          <h3>OS Installation</h3>
          <p>Windows installation, drivers & software setup.</p>
        </div>

        <div className="service-box">
          <span>📞</span>
          <h3>Technical Support</h3>
          <p>Friendly support & guidance even after purchase.</p>
        </div>
      </div>
    </div>





      <section className="contact">
        <div>
          <h2 className="get">Get in Touch</h2>
          <p>📞 +91 8838619488</p>
          <p>✉️ <a href="mailto:lappylaptopsales@gmail.com" className="contact-email-link">lappylaptopsales@gmail.com</a></p>
          <p>📍 129 Salapalayam Road, Reddipatti, Namakkal, TamilNadu 637002</p>
          <p>📍 Lappy Laptops, 27, Devangar Street, Thathiengarpettai, Musiri-Tk, Trichy-Dt, Pincode: 621214. Landmark: Mini Radios.</p>
          <a
            href="https://wa.me/918838619488"
            target="_blank"
            rel="noreferrer"
            className="whatsapp"
          >
            WhatsApp Us
          </a>
        </div>

        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.730200578514!2d78.22037987429323!3d11.207586751094425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babc94be384bbb3%3A0xcdd0430efbea64f3!2sLappy%20Used%20Laptops%20Sales!5e0!3m2!1sen!2sin!4v1770279618891!5m2!1sen!2sin"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            title="Lappy Location"
          ></iframe>
        </div>
      </section>

      {/* FOOTER */}
      <SiteFooter />










</>


  );
}

export default Services;


